import ToDoContainer from "../../Componant/ToDo";

const ToDo = () => {
  return (
    <div className="page-body">
      <ToDoContainer />
    </div>
  );
};

export default ToDo;
